import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { Constrain, Stack, Text } from '@moda/om';
import ChevronLeftIcon from '@moda/icons/chevron-left-16';
import { PaymentSource } from '../../constants';
import { useUser } from '../../hooks/useUser';
import { useCart } from '../../hooks/useCart';
import { useCheckout } from '../../hooks/useCheckout';
import { hrefFor } from '../../routers';
import { CheckoutHeaderStep } from './CheckoutHeaderStep';

import './CheckoutHeader.scss';

export const CheckoutHeader: React.FC = () => {
  const {
    user: { accessToken }
  } = useUser();
  const {
    cart: {
      attributes: { paymentSource }
    }
  } = useCart();
  const { isShippingAddressSelected, isPaymentMethodSelected } = useCheckout();

  return (
    <header
      className={classNames('CheckoutHeader', {
        'CheckoutHeader--with-steps': accessToken,
        [`CheckoutHeader--${paymentSource?.toLowerCase()}`]: paymentSource
      })}
    >
      <Constrain>
        <div className="CheckoutHeader__content">
          <Link className="CheckoutHeader__link" to={hrefFor.ShoppingBagPage()}>
            <Stack direction="horizontal" space={2} alignItems="center">
              <ChevronLeftIcon />
              <Text className="CheckoutHeader__link-text">Return to Shopping Bag</Text>
            </Stack>
          </Link>
          <h1 className="CheckoutHeader__title">Secure Checkout</h1>
          {accessToken && (
            <Stack
              className="CheckoutHeader__steps"
              direction="horizontal"
              space={0}
              justifyContent="space-between"
            >
              {(paymentSource === PaymentSource.Adyen ||
                paymentSource === PaymentSource.Moda ||
                paymentSource === PaymentSource.Affirm) && (
                <>
                  <CheckoutHeaderStep title="Shipping" checked={isShippingAddressSelected} />
                  <CheckoutHeaderStep title="Payment" checked={isPaymentMethodSelected} />
                </>
              )}
              {(paymentSource === PaymentSource.Amazon ||
                paymentSource === PaymentSource.PayPal) && (
                <>
                  <CheckoutHeaderStep
                    title="Shipping &amp; Payment"
                    checked={isShippingAddressSelected && isPaymentMethodSelected}
                  />
                </>
              )}
              <CheckoutHeaderStep title="Review" />
            </Stack>
          )}
        </div>
      </Constrain>
    </header>
  );
};
